(function () {
  'use strict';

  var config = window.PERSN_TRACKING_CONFIG || {};
  var currency = config.currency || 'EUR';
  var clickIdKeys = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  var cartState = null;
  var lastKnownEcommerceItems = [];
  var checkoutStarted = false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  function nowSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  function centsToAmount(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 0;
    return Math.round(number) / 100;
  }

  function setCookie(name, value, days) {
    if (!value) return;
    var maxAge = days * 24 * 60 * 60;
    document.cookie = [
      encodeURIComponent(name) + '=' + encodeURIComponent(value),
      'Max-Age=' + maxAge,
      'Path=/',
      'SameSite=Lax',
      location.protocol === 'https:' ? 'Secure' : ''
    ].filter(Boolean).join('; ');
  }

  function getCookie(name) {
    var encodedName = encodeURIComponent(name) + '=';
    return document.cookie.split(';').map(function (part) {
      return part.trim();
    }).reduce(function (found, part) {
      if (found || part.indexOf(encodedName) !== 0) return found;
      try {
        return decodeURIComponent(part.slice(encodedName.length));
      } catch (error) {
        return part.slice(encodedName.length);
      }
    }, '');
  }

  function getStoredClickId(key) {
    try {
      return window.localStorage.getItem('persn_' + key) || getCookie('persn_' + key);
    } catch (error) {
      return getCookie('persn_' + key);
    }
  }

  function getStoredClickIdTimestampMs(key) {
    try {
      var seconds = Number(window.localStorage.getItem('persn_' + key + '_ts'));
      if (Number.isFinite(seconds) && seconds > 0) return seconds * 1000;
    } catch (error) {}
    return Date.now();
  }

  function buildFbcFromFbclid() {
    var fbclid = getStoredClickId('fbclid');
    if (!fbclid) return '';
    return ['fb', '1', Math.round(getStoredClickIdTimestampMs('fbclid')), fbclid].join('.');
  }

  function persistMetaClickCookiesToCart() {
    if (!window.fetch) return;
    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc') || buildFbcFromFbclid();
    var fbclid = getStoredClickId('fbclid');
    if (!fbp && !fbc && !fbclid) return;

    var attributes = {
      _fbp: fbp || '',
      _fbc: fbc || '',
      _fbclid: fbclid || '',
      persn_capi_cookie_captured_at: new Date().toISOString()
    };
    var signature = [attributes._fbp, attributes._fbc, attributes._fbclid].join('|');

    try {
      if (window.sessionStorage.getItem('persn_capi_cart_signature') === signature) return;
      window.sessionStorage.setItem('persn_capi_cart_signature', signature);
    } catch (error) {}

    window.fetch('/cart/update.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {
      try {
        window.sessionStorage.removeItem('persn_capi_cart_signature');
      } catch (error) {}
    });
  }

  function captureClickIds() {
    var params = new URLSearchParams(window.location.search);
    clickIdKeys.forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      try {
        window.localStorage.setItem('persn_' + key, value);
        window.localStorage.setItem('persn_' + key + '_ts', String(nowSeconds()));
      } catch (error) {
        // localStorage can be unavailable in private browsing modes.
      }
      setCookie('persn_' + key, value, 90);
    });
  }

  function configureGoogleConsentMode() {
    window.gtag('set', 'url_passthrough', true);
    window.gtag('set', 'ads_data_redaction', false);
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500
    });
  }

  function normalizeCartItems(items) {
    return (items || []).map(function (item) {
      var quantity = Number(item.quantity || 1);
      var unitPrice = centsToAmount(item.final_price != null ? item.final_price : item.price);
      return {
        item_id: String(item.variant_id || item.id || ''),
        item_name: item.product_title || item.title || item.name || '',
        item_variant: item.variant_title || '',
        item_brand: item.vendor || '',
        item_sku: item.sku || '',
        item_category: item.product_type || '',
        price: unitPrice,
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        shopify_product_id: item.product_id || '',
        shopify_variant_id: item.variant_id || item.id || ''
      };
    }).filter(function (item) {
      return item.item_id || item.item_name;
    });
  }

  function ecommerceValue(items) {
    return items.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);
  }

  function pushEvent(eventName, ecommerce, meta) {
    var payload = {
      event: eventName,
      event_id: 'persn_' + eventName + '_' + Date.now(),
      ecommerce: ecommerce || {},
      persn_tracking: meta || {}
    };

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, Object.assign({}, ecommerce, {
        event_id: payload.event_id
      }));
    }

    if (typeof window.fbq === 'function') {
      if (eventName === 'add_to_cart') {
        window.fbq('track', 'AddToCart', {
          currency: ecommerce.currency,
          value: ecommerce.value,
          content_ids: (ecommerce.items || []).map(function (item) { return item.item_id; }),
          contents: (ecommerce.items || []).map(function (item) {
            return { id: item.item_id, quantity: item.quantity, item_price: item.price };
          }),
          content_type: 'product'
        });
      } else if (eventName === 'view_item') {
        window.fbq('track', 'ViewContent', {
          currency: ecommerce.currency,
          value: ecommerce.value,
          content_ids: (ecommerce.items || []).map(function (item) { return item.item_id; }),
          content_type: 'product'
        });
      } else if (eventName === 'begin_checkout') {
        window.fbq('track', 'InitiateCheckout', {
          currency: ecommerce.currency,
          value: ecommerce.value,
          num_items: (ecommerce.items || []).reduce(function (sum, item) {
            return sum + (Number(item.quantity) || 1);
          }, 0),
          content_ids: (ecommerce.items || []).map(function (item) { return item.item_id; }),
          content_type: 'product'
        });
      }
    }
  }

  function normalizeCartAddResponse(responseBody) {
    if (!responseBody || responseBody.status) return [];
    if (Array.isArray(responseBody.items)) return normalizeCartItems(responseBody.items);
    return normalizeCartItems([responseBody]);
  }

  function publishAddToCart(responseBody, source) {
    var items = normalizeCartAddResponse(responseBody);
    if (!items.length) return;
    lastKnownEcommerceItems = items;
    pushEvent('add_to_cart', {
      currency: currency,
      value: ecommerceValue(items),
      items: items
    }, {
      source: source,
      cart_api_intercepted: true
    });
    refreshCartState();
  }

  function isCartAddUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(parsed.pathname);
    } catch (error) {
      return false;
    }
  }

  function isThemeProductFormAdd(init) {
    var body = init && init.body;
    return body instanceof FormData && body.has('sections') && body.has('sections_url');
  }

  function interceptFetchCartAdds() {
    if (!window.fetch || window.fetch.__persnTrackingWrapped) return;
    var originalFetch = window.fetch;
    var wrappedFetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var shouldInspect = isCartAddUrl(requestUrl) && !isThemeProductFormAdd(init);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (shouldInspect && response && response.ok) {
          response.clone().json().then(function (body) {
            publishAddToCart(body, 'fetch_cart_add');
          }).catch(function () {});
        }
        return response;
      });
    };
    wrappedFetch.__persnTrackingWrapped = true;
    window.fetch = wrappedFetch;
  }

  function interceptXhrCartAdds() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__persnTrackingWrapped) return;
    var OriginalXhr = window.XMLHttpRequest;
    var originalOpen = OriginalXhr.prototype.open;
    var originalSend = OriginalXhr.prototype.send;

    OriginalXhr.prototype.open = function (method, url) {
      this.__persnCartAddUrl = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    OriginalXhr.prototype.send = function () {
      if (this.__persnCartAddUrl) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            publishAddToCart(JSON.parse(this.responseText), 'xhr_cart_add');
          } catch (error) {}
        });
      }
      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__persnTrackingWrapped = true;
  }

  function publishViewItem() {
    var product = window.PERSN_PRODUCT_VIEW_ITEM;
    if (!product || !product.items || !product.items.length) return;
    var item = product.items[0];
    if (!item || Number(item.price) <= 0) return;
    pushEvent('view_item', {
      currency: product.currency || currency,
      value: Number(item.price) || 0,
      items: product.items
    }, {
      source: 'theme_product_page'
    });
  }

  function refreshCartState() {
    if (!window.fetch) return;
    window.fetch((window.theme && window.theme.routes && window.theme.routes.cart_url || '/cart') + '.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (cart) {
      if (!cart) return;
      cartState = cart;
    }).catch(function () {});
  }

  function publishBeginCheckout() {
    if (checkoutStarted) return;
    checkoutStarted = true;
    var items = cartState && cartState.items && cartState.items.length
      ? normalizeCartItems(cartState.items)
      : lastKnownEcommerceItems;
    pushEvent('begin_checkout', {
      currency: cartState && cartState.currency || currency,
      value: cartState ? centsToAmount(cartState.total_price) : ecommerceValue(items),
      items: items
    }, {
      source: 'checkout_navigation'
    });
  }

  function isCheckoutTarget(element) {
    var target = element && element.closest && element.closest('a[href], button, input[type="submit"]');
    if (!target) return false;
    var href = target.getAttribute && target.getAttribute('href');
    var name = target.getAttribute && target.getAttribute('name');
    var action = target.form && target.form.getAttribute('action');
    return name === 'checkout' || /\/checkout(?:\?|$)/.test(href || '') || /\/cart(?:\?|$)/.test(action || '') && name === 'checkout';
  }

  function bindCheckoutTracking() {
    document.addEventListener('pointerdown', function (event) {
      if (isCheckoutTarget(event.target)) publishBeginCheckout();
    }, true);

    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var action = event.target && event.target.getAttribute && event.target.getAttribute('action');
      if ((submitter && submitter.getAttribute('name') === 'checkout') || /\/checkout(?:\?|$)/.test(action || '')) {
        publishBeginCheckout();
      }
    }, true);
  }

  captureClickIds();
  persistMetaClickCookiesToCart();
  configureGoogleConsentMode();
  interceptFetchCartAdds();
  interceptXhrCartAdds();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      persistMetaClickCookiesToCart();
      publishViewItem();
      refreshCartState();
      bindCheckoutTracking();
    });
  } else {
    persistMetaClickCookiesToCart();
    publishViewItem();
    refreshCartState();
    bindCheckoutTracking();
  }

  window.setTimeout(persistMetaClickCookiesToCart, 1500);
  window.setTimeout(persistMetaClickCookiesToCart, 5000);
})();
